import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Page} from '../../../model/page';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/delay';

import {Router} from '@angular/router';
import {permissions} from '../../../permissions';
import {AuthService} from '../../../auth/auth.service';
import {MasterCustomerService} from '../services/master-customer.service';
import {ToastrService} from 'ngx-toastr';
import {IMasterCustomer} from '../interfaces/IMasterCustomer';
import {ConfirmationService} from 'primeng/api';
import {Title} from '@angular/platform-browser';

@Component({
    templateUrl: './master-customer.component.html',
    providers: [
        AuthService,
        MasterCustomerService,
    ]
})

export class MasterCustomerComponent implements OnInit {

    @ViewChild('customerDataView') customerDataView: ElementRef;
    @ViewChild('actionbar') actionbar: ElementRef;
    @ViewChild('content')       content: ElementRef;
    @ViewChild('tableHeader')   tableHeader:  ElementRef;
    @ViewChild('paginator')     paginator:  ElementRef;

    public page = new Page();
    rows = new Array<object>();
    cols = [];
    totalRecords = 0;
    size = 50;
    public selected: IMasterCustomer = null;
    private viewFilters = false;
    public loading = false;

    public scrollHeight = '50px';
    private dialogContentHeight = '150px';

    private confirmFlags: Array<object> = [
        {value: null, text: 'All'},
        {value: '1',  text: 'Yes'},
        {value: '0',  text: 'No'}
    ];

    public permissions = permissions;

    constructor(
        private customerService: MasterCustomerService,
        private authService: AuthService,
        private router: Router,
        private toastr: ToastrService,
        private confirmationService: ConfirmationService,
        private title: Title
    ) {
        this.page.pageNumber = 0;
        this.page.size = 50;
        this.title.setTitle('Admin - Master Customers');
    }

    ngOnInit() {
        this.cols = [
            { field: 'CU0_SHORT_CODE', header: 'Short code', visible: true, export: {visible: true, checked: true}, width: 110},
            { field: 'CU0_NAME', header: 'Name', visible: true, export: {visible: true, checked: true}, width: 150},
            { field: 'CU0_TYPE', header: 'Type', visible: true, export: {visible: true, checked: true}, width: 100},
            { field: 'CU0_ALLOW_DUPLICATE_BARCODES', header: 'Allow Duplicate Barcodes', visible: true, export: {visible: true, checked: true}, width: 100},
            { field: 'CU0_ALLOW_INVENTORY_MANAGEMENT', header: 'Allow Inventory Management', visible: true, export: {visible: true, checked: true}, width: 100},
            { field: 'CU0_MODIFIED_ON', header: 'Last Update', visible: true, export: {visible: true, checked: true}, width: 100},
        ];
        this.getData();
    }

    getData() {
        this.setPage({offset: this.page.pageNumber});
    }

    clearSingleSelection() {
        this.selected = null;
    }

    setPage(pageInfo) {
        this.loading = true;
        this.selected = null;
        this.page.pageNumber = pageInfo.offset ? pageInfo.offset : 0;
        this.page.size = pageInfo.size ? pageInfo.size : this.size;
        this.size = pageInfo.size ? pageInfo.size : this.size;

        this.customerService.getDataList(this.page).subscribe(result => {
            this.rows = result.data;
            this.totalRecords = result.count;
            this.page.totalPages = result.count / this.page.size;
            this.loading = false;
            setTimeout(() => { this.scrollHeight = this.getScrollHeight() + 'px'; }, 200);
        }, error => {
            this.loading = false;
            window.dispatchEvent(new Event('resize'));
            this.toastr.error('TimeOut occured', 'Service Error', {
                timeOut: 3000,
            });
        });
    }

    buttonPress(e, col, value) {
        if ( e.keyCode === 13 ) {
          this.filterChanged(col, value);
        }
    }

    filterChanged(col, value) {
        this.loading = true;
        if ((col === 'ORDERED_ON' || col === 'COMPLETED_ON' || col === 'MODIFIED_ON' || col === 'CREATED_ON') && value === '01-01-1970' || value === '') {
          delete this.page.filterParams[col];
        } else {
          this.page.filterParams[col] = value;
        }
        this.page.pageNumber = 0;
        this.setPage({offset: this.page.pageNumber});
    }

    getContentDialogHeight(): number {
        return (this.customerDataView.nativeElement.parentElement.parentElement.parentElement.offsetHeight) -
        (this.actionbar.nativeElement.offsetHeight + 48);
    }

    getScrollHeight(): number {
        return this.getContentDialogHeight() - (this.tableHeader.nativeElement.offsetHeight + this.paginator.nativeElement.offsetHeight);
    }

    get masterDataViewHeight() {
        return this.customerDataView.nativeElement.parentElement.parentElement.parentElement.offsetHeight
    }

    get masterActionBarHeight() {
        return this.actionbar.nativeElement.offsetHeight + 48
    }

    exportClick() {
        return '';
    }

    onPage($event) {
        this.setPage({
            offset: $event.first / $event.rows,
            size: $event.rows
        });
    }

    onEdit(rowData){
        this.router.navigate(['order-entry-system/master-customers/edit/' + rowData['CU0_ID']]);
    }

    deleteClick() {
        if (this.selected) {
            this.confirmationService.confirm({
                header: 'Delete Master Customer',
                message: 'Are you sure to delete master customer ' + this.selected.CU0_NAME + '?',
                accept: () => {
                    this.customerService.delete(this.selected).subscribe((result) => {
                        if (result.success) {
                            this.toastr.info('Master Customer deleted', 'Request Complete');
                            this.getData();
                        } else {
                            this.toastr.error('Unable to delete the Master Customer', 'Error');
                        }
                    }, () => {
                        this.toastr.error('Request timed out', 'Service Error');
                    });
                }
            })
        }
    }

    refreshClick() {
        this.getData();
    }

    toggleFilterView() {
        this.viewFilters = !this.viewFilters;
    }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/oes/master-customer/master-customer.component.ts